import { FormControlLabel, Switch } from '@mui/material';
import { MatchAccessibility } from '@okletsplay/core/src/modules/match/enums';
import React, { ChangeEvent, FC, useCallback } from 'react';

interface MatchAccessibilityProps {
  value: MatchAccessibility;
  onChange: (value: MatchAccessibility) => void;
}

export const MatchModeSwitcher: FC<MatchAccessibilityProps> = ({ value, onChange }) => {
  const onChangeHandler = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.checked ? MatchAccessibility.Private : MatchAccessibility.Public);
    },
    [onChange]
  );

  return (
    <FormControlLabel
      control={
        <Switch
          checked={value === MatchAccessibility.Private}
          onChange={onChangeHandler}
          name="match-type"
        />
      }
      label="Private match?"
    />
  );
};
